
export const getBreadCrumbObj = (breadCrumbObj = {}) => {
    let itemList = [];
    if (breadCrumbObj && breadCrumbObj.length) {
      for (let i in breadCrumbObj) {
        let { title, url } = breadCrumbObj[i];
        let itemListObj = {
          "@type": "ListItem",
          "position": +i + 1,
          "item": {
            "@type": "WebPage",
            "@id": url,
            "name": title,
          }
        }
        itemList.push(itemListObj);
      }
    }
    const obj = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": itemList
    };
    return obj;  
}
